module.exports = __webpack_public_path__ + "static/media/kaneki.48bb9b45.jpeg";